import { Box } from "@mui/material";
import { map, path, pipe } from "ramda";
import React, { cloneElement } from "react";

const HyroOptionGroup = ({ children, value, handleChange }) => (<Box display="flex" columnGap="24px" justifyContent="flex-start">
  {map(child =>
    cloneElement(child, {
      key: child.props.name,
      selected: child.props.name === value,
      onClick: () => pipe(path(["props", "name"]), handleChange)(child),
      ...child.props
    })
  )(children)}
</Box>);

export default HyroOptionGroup;
